module.exports = __webpack_public_path__ + "media/images/icons/telephone-fill-92e390f92427328323834e1b8ab89138.svg";